import gql from "graphql-tag";

import { metadataFragment } from "./metadata";

export const pageFragment = gql`
  fragment PageFragment on Page {
    id
    title
    slug
    isPublished
    url
  }
`;

export const pageDetailsFragment = gql`
  ${pageFragment}
  ${metadataFragment}
  fragment PageDetailsFragment on Page {
    ...PageFragment
    ...MetadataFragment
    contentJson
    seoTitle
    seoKeyword
    seoDescription
    publicationDate
  }
`;

export const userOperatePageEventFragment = gql`
  fragment UserOperatePageEventFragment on UserOperatePageEvent {
    id
    email
    operateType
    eventDate
    releaseUrl
    languageCode
    template {
      thumbnailUrl
      title
    }
  }
`;
